<div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show"
  tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex;">
  <div class="swal2-header">
    <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
      <div class="swal2-icon-content">!</div>
    </div>
    <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@AreYouSure?Header">Sind Sie sicher?</h2>
  </div>
  <div class="swal2-content">
    <div id="swal2-content" class="swal2-html-container" style="display: block;"
      i18n="@@ConfirmByEnteringPasswordMessage">Bitte geben Sie zur Bestätigung das aktuelle Passwort ein.</div>

    <app-message [service]="messageService"></app-message>

    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
      <div class="mb-2 mt-2">
        <input id="currentPassword" formControlName="currentPassword" name="currentPassword" type="password"
          class="form-control" [class]="isWrongPassword ? 'ng-invalid' : ''" (keydown)="resetWrongPassword()">
        <div class="error">
          <em
            *ngIf="formService.validateControl('currentPassword') && formService.hasError('currentPassword', 'required')"
            i18n="@@PasswordRequiredError">Passwort wird benötigt</em>
          <em
            *ngIf="isWrongPassword"
            i18n="@@PasswordWrongError">Das eingegebene Passwort ist falsch</em>
        </div>
      </div>
    </form>
  </div>
  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">
      <button type="submit" id="delete_custormer" class="btn btn-danger me-2" [disabled]="!formService.form.valid"
        aria-label="" i18n="@@ConfirmDeleteCustomerAccountButton">Konto löschen</button>
    </form>
    <button type="button" id="cancel" class="btn btn-yellow" (click)="onCancelClick()" aria-label=""
      i18n="@@CancelButton">Abbrechen</button>
  </div>
</div>